import { BritishGasBenefits } from 'components/direct-sales/quote/components/BritishGasBenefits';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import DirectDebitFooter from 'components/direct-sales/direct-debit-revamp/components/DirectDebitFooter';

export const quoteExpiredFooterTestId = 'quoteExpiredFooterTestId';

export const QuoteExpiredFooter = () => {
  return(
    <div data-testid={quoteExpiredFooterTestId}>
      <NsPanel decoration="white">
        <BritishGasBenefits />
      </NsPanel>
      <DirectDebitFooter/>
    </div>
  )
}

export default QuoteExpiredFooter;